import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/x-dots.svg'


const _withScopeId = n => (_pushScopeId("data-v-e5edcffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%","height":"100%","object-fit":"cover","position":"absolute"},
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "login-box" }
const _hoisted_4 = {
  key: 0,
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "sign-in-text" }
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "login-actions" }
const _hoisted_9 = { style: {"height":"50px"} }
const _hoisted_10 = {
  key: 0,
  style: {"text-align":"center"},
  class: "login-error animated-fast"
}
const _hoisted_11 = {
  key: 0,
  class: "login-success animated-fast"
}
const _hoisted_12 = {
  key: 0,
  class: "need-help"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-arrow-left" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("activateAccount.title")), 1),
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.success)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("activateAccount.accountInactiveWarning")), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_Transition, {
                    "enter-active-class": "fadeInUp",
                    "leave-active-class": "fadeOutDown"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.errorMessage != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_Transition, {
                    "enter-active-class": "fadeInUp",
                    "leave-active-class": "fadeOutDown"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.success)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.successMessage), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (!_ctx.success || _ctx.success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("a", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutAndBack && _ctx.logoutAndBack(...args)))
                      }, [
                        _hoisted_13,
                        _createTextVNode("   " + _toDisplayString(_ctx.$t("activateAccount.backToLogin")), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_imdex_spinner, {
            key: 1,
            size: "5",
            width: "50"
          }))
    ])
  ]))
}